<template>
  <ul class="nav dq-gs-top-tabs border-0 mb-3" role="tablist">
    <li class="nav-item">
      <router-link
        class="nav-link"
        :class="{ active: currentPath.includes('general-settings') }"
        to="/general-settings/profile-settings"
      >
        <i class="ti ti-adjustments-horizontal me-2"></i>General Settings
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        class="nav-link"
        :class="{
          active:
            currentPath.includes('system-settings/email-settings') ||
            currentPath.includes('system-settings/email-template'),
        }"
        to="/system-settings/email-settings"
      >
        <i class="ti ti-server-cog me-2"></i>System Settings
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
        class="nav-link"
        :class="{
          active:
            currentPath.includes('others-settings/custom-js') ||
            currentPath.includes('others-settings/cronjob') ||
            currentPath.includes('others-settings/storage-settings') ||
            currentPath.includes('others-settings/ban-ip-address') ||
            currentPath.includes('others-settings/backup') ||
            currentPath.includes('others-settings/clear-cache'),
        }"
        to="/others-settings/cronjob"
      >
        <i class="ti ti-settings-2 me-2"></i>Other Settings
      </router-link>
    </li>
  </ul>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const currentPath = computed(() => route.path);
</script>
